
import { createContext } from "react";

const Profilecontext = createContext();

export default Profilecontext;